export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_night_320.569e1ee7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};